<script setup lang="ts">
import { Button, Tooltip } from 'ant-design-vue';
import { CopyOutlined } from '@ant-design/icons-vue';

import useCopytoClipboard from '@/util/useCopytoClipboard';

interface Props {
  value: string;
  size?: 'small' | 'middle' | 'large';
  type?: 'default' | 'primary' | 'ghost' | 'dashed' | 'link' | 'text';
}

const properties = defineProps<Props>();

const { onCopy } = useCopytoClipboard();

function handleCopy() {
  onCopy(properties.value);
}
</script>

<template>
  <Tooltip title="Copy to clipboard">
    <Button
      :size="size"
      :type="type"
      @click="handleCopy"
    >
      <CopyOutlined />
    </Button>
  </Tooltip>
</template>
